import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, autorun} from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, {FormBody, FormActions, TextInput, SelectInput} from '../Form';
import CronIntervalInput from "../CronIntervalInput";

@inject('daqProcessorStore', 'daqLocationStore', 'dataSourceStore')
@observer
class DaqProcessorEdit extends Component {
  // static propTypes = {
  // route: PropTypes.shape().isRequired,
  // params: PropTypes.shape({
  // id: PropTypes.string.isRequired,
  // }).isRequired,
  // daqProcessorStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug;
  title = 'Edit DAQ Processor';
  // locationKeys = [
  //   'source_location',
  //   'destination_location',
  //   'user_name',
  //   'user_password',
  //   'interval',
  //   'mqtt_topic',
  //   'certificate'
  // ]
  locationKeys = {
    '1': {},
    '3': {
      'source_location': 'Source Location',
      'destination_location': 'Destination Location',
      'user_name': 'User Name',
      'user_password': 'User Password',
      'interval': 'Interval',
    },
    '4': {
      'source_location': 'Source Location',
      'destination_location': 'Destination Location',
      'interval': 'Interval',
    },
    '5': {
      'user_name': 'User Name',
      'user_password': 'User Password',
      'mqtt_topic': 'MQTT Topic',
      'source_location': 'Client ID',
    },
    '6': {
      'user_name': 'User Name',
      'user_password': 'User Password',
      'mqtt_topic': 'Database Name',
      'source_location': 'Source Table',
      'destination_location': 'Destination Table',
      'interval': 'Interval',
    },
    '7': {
      'source_location': 'Source Table',
      'interval': 'Interval',
    }
  };

  @observable item = {
    protocol: '',
    // data_source_id: '',
    parser: '',
    aes_key: '',
    // location_id: '',
    address: '',
    port_no: '',
    location: {
      source_location: '',
      destination_location: '',
      user_name: '',
      user_password: '',
      interval: '',
      mqtt_topic: '',
      certificate: '',
    }
  };
  @observable resolved = false;

  // constructor(props) {
  // super(props);

  // }

  componentWillMount() {
    const {params: {id, daqProcessorId}, daqProcessorStore} = this.props;
    this.slug = `/daq/daq-processor`;

    // daqProcessorStore.fetchItem(daqProcessorId)
    // .then(action(item => {
    // this.item = item;
    // }))
    // ;
    this.reset();
  }

  @action reset() {
    const {params: {id, daqProcessorId}, daqProcessorStore} = this.props;
    const dispose = autorun(() => {
      const foundDaqProcessor = daqProcessorStore.findById(daqProcessorId);
      if (foundDaqProcessor) {
        this.item = foundDaqProcessor.asJson;
        dispose();
      }
    });
  }

  // @action onChangeDataSource = e => this.item.data_source_id = e.target.value;
  @action onChangeParser = e => this.item.parser = e.target.value;
  @action onChangeProtocol = e => this.item.protocol = e.target.value;
  @action onChangeAesKey = e => this.item.aes_key = e.target.value;
  @action onChangeLocation = e => this.item.location_id = e.target.value;
  @action onChangePortNo = e => this.item.port_no = e.target.value;
  @action onChangeAddress = e => this.item.address = e.target.value;
  @action onChangeLocationItem = (e, key) => this.item.location[key] = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const {daqProcessorStore} = this.props;
    daqProcessorStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  };

  render() {
    const {daqProcessorStore, params: {id, daqProcessorId}, daqLocationStore, dataSourceStore} = this.props;

    if (daqProcessorStore.isLoading) {
      return <Spinner/>;
    }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={daqProcessorStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={daqProcessorId} readOnly/>
            {/*<SelectInput*/}
            {/*label={'Data Source'}*/}
            {/*value={this.item.data_source_id}*/}
            {/*options={dataSourceStore.items}*/}
            {/*fields={{ label: 'name', value: 'id' }}*/}
            {/*onChange={this.onChangeDataSource}*/}
            {/*/>*/}
            {/* <TextInput
              label={'Protocol'}
              value={this.item.protocol}
              onChange={this.onChangeProtocol}
            /> */}
            <SelectInput
              label={'Protocol'}
              value={this.item.protocol}
              options={daqProcessorStore.protocolOptions}
              fields={{label: 'name', value: 'id'}}
              onChange={this.onChangeProtocol}
            />
            <TextInput
              label={'Parser'}
              value={this.item.parser}
              onChange={this.onChangeParser} readOnly
            />
            <TextInput
              label={'AES Key'}
              value={this.item.aes_key}
              onChange={this.onChangeAesKey}
            />
            {/*<SelectInput*/}
              {/*label={'Location'}*/}
              {/*value={this.item.location_id}*/}
              {/*onChange={this.onChangeLocation}*/}
              {/*options={daqLocationStore.items.map(item => ({*/}
                {/*id: item.id,*/}
                {/*label: `${item.source_location} - ${item.destination_location}`*/}
              {/*}))}*/}
              {/*fields={{label: 'label', value: 'id'}}*/}
            {/*/>*/}
            <TextInput
              label={'Address'}
              value={this.item.address}
              onChange={this.onChangeAddress}
            />
            <TextInput
              label={'Port No.'}
              value={this.item.port_no}
              onChange={this.onChangePortNo}
            />


          </FormBody>
          <hr/>
          <FormBody>
            {!!this.item.protocol && !!this.locationKeys[this.item.protocol] && Object.keys(this.locationKeys[this.item.protocol]).map(key => {
              let InputComponent = key === 'interval' ? CronIntervalInput : TextInput;
              return (
                <InputComponent type={key === 'user_password' ? 'password' : 'text'} value={this.item.location && this.item.location[key]} autoComplete={false} autoSuggest={false}
                                label={this.locationKeys[this.item.protocol][key]} onChange={e => this.onChangeLocationItem(e, key)}
                                key={`daq-processor-location-edit-item-key-${key}`}/>
              )
            })}
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DaqProcessorEdit;



// WEBPACK FOOTER //
// ./src/components/DataSource/DaqProcessorEdit.js